import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FloatingActionBar, FloatingActionBarItem } from '@helix/floating-action-bar';
import { add_to_list, inbox } from '@lwt-helix/helix-icon/outlined';
import { ToastContainer } from '@lwt-helix/toast';
import SavedAgentListsModal from './SavedAgentListsModal';
import { favoriteAgentTerms as favTerms } from '../../constants/agentProductionConstants';

const AgentsFloatingActionBar = ({
    selectedCount,
    showAddToListModal,
    setShowAddToListModal,
    onDismiss,
    onDownloadClick,
}) => {
    const [toastProps, setToastProps] = useState(null);

    return (
        <>
            <FloatingActionBar
                show={!!selectedCount}
                itemsSelected={selectedCount}
                onDismiss={onDismiss}
            >
                <FloatingActionBarItem
                    icon={add_to_list}
                    id="addToList"
                    label={favTerms.addToList}
                    onClick={() => setShowAddToListModal(true)}
                />
                <FloatingActionBarItem
                    icon={inbox}
                    id="download"
                    label={favTerms.download}
                    onClick={onDownloadClick}
                />
            </FloatingActionBar>
            <SavedAgentListsModal
                shouldShowModal={showAddToListModal}
                onClose={() => setShowAddToListModal(false)}
                selectedCount={selectedCount}
                setToastProps={setToastProps}
            />
            {toastProps && (
                <ToastContainer
                    dataLwtId='agents-bulk-add-toast'
                    toastProps={toastProps.toastProps}
                    position='toast-bottom-right'
                />
            )}
        </>
    );
};

AgentsFloatingActionBar.propTypes = {
    selectedCount: PropTypes.number.isRequired,
    showAddToListModal: PropTypes.bool.isRequired,
    setShowAddToListModal: PropTypes.func.isRequired,
    onDismiss: PropTypes.func,
    onDownloadClick: PropTypes.func,
};

export default AgentsFloatingActionBar;
